import React, {PureComponent} from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import TopbarSidebarButton from './TopbarSidebarButton';
import TopbarProfile from './TopbarProfile';

class Topbar extends PureComponent {
    static propTypes = {
        changeMobileSidebarVisibility: PropTypes.func.isRequired,
        changeSidebarVisibility: PropTypes.func.isRequired,
    };

    render() {
        const {changeMobileSidebarVisibility, changeSidebarVisibility} = this.props;

        return (
            <div className="topbar">
                <div className="topbar__wrapper">
                    <div className="topbar__left">
                        {/*<TopbarProfile/>*/}
                    </div>
                    <div className="topbar__right">
                        {this.props.showNumber && <h3 style={{textAlign: 'right', color: 'green', marginTop: 'auto', marginBottom: 'auto', marginRight: '10px'}}>ברוכים הבאים למערכת ש.רומי</h3>}
                        <Link className="topbar__logo" to="/dashboard"/>
                        <TopbarSidebarButton
                            changeMobileSidebarVisibility={changeMobileSidebarVisibility}
                            changeSidebarVisibility={changeSidebarVisibility}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default Topbar;
